
import { AloDbEnseigne, IAloDbEnseigneConstParam } from '@/models/alodb/AloDbEnseigne';
import { FilterBase } from '@/models/filter/FilterBase';

export interface IEnseigneState {
    status:string
    enseignes: Array<AloDbEnseigne>
    modifiedAdmEnseigne: AloDbEnseigne
    originalAdmEnseigne: AloDbEnseigne
    enseigneLoading: boolean
    adminFilter: FilterBase
}
  
const state:IEnseigneState = { 
    status: '',
    enseignes: [],
    modifiedAdmEnseigne: new AloDbEnseigne(),
    originalAdmEnseigne: new AloDbEnseigne(),
    enseigneLoading:false,
    adminFilter: new FilterBase()
}
  
export default state